import "./Level3.scss";

export default function Level3() {
  return (
    <div className="level3__container">
      <div className="level3__puzzle">
        <div className="level3__file">
          <p className="level3__letter">A</p>
          <p className="level3__clue">5</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">B</p>
          <p className="level3__clue">3</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">C</p>
          <p className="level3__clue">2</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">D</p>
          <p className="level3__clue">4</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">E</p>
          <p className="level3__clue">7</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">F</p>
          <p className="level3__clue">1</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">G</p>
          <p className="level3__clue">10</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">H</p>
          <p className="level3__clue">12</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">I</p>
          <p className="level3__clue">8</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">J</p>
          <p className="level3__clue">23</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">K</p>
          <p className="level3__clue">15</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">L</p>
          <p className="level3__clue">19</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">M</p>
          <p className="level3__clue">11</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">N</p>
          <p className="level3__clue">17</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">O</p>
          <p className="level3__clue">9</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">P</p>
          <p className="level3__clue">6</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">Q</p>
          <p className="level3__clue">20</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">R</p>
          <p className="level3__clue">22</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">S</p>
          <p className="level3__clue">26</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">T</p>
          <p className="level3__clue">13</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">U</p>
          <p className="level3__clue">18</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">V</p>
          <p className="level3__clue">16</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">W</p>
          <p className="level3__clue">25</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">X</p>
          <p className="level3__clue">21</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">Y</p>
          <p className="level3__clue">24</p>
        </div>
        <div className="level3__file">
          <p className="level3__letter">Z</p>
          <p className="level3__clue">14</p>
        </div>
      </div>

      <div className="level3__guess-container">
        <span className="level3__guess">
          2 &nbsp; 9 &nbsp; 11 &nbsp; (O/B)(J-R+F) &nbsp; 19 &nbsp; P-B+D &nbsp;
          13 &nbsp; 5 &nbsp; 4 &nbsp; 9
        </span>
      </div>
    </div>
  );
}
